import React, { useEffect, useState } from "react";
import OwlCarousel from "react-owl-carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { toast } from "react-toastify";
import { Link, useParams } from "react-router-dom";
const CorporateGifting = () => {
  const { id } = useParams();
  const [hamperList, setHamperList] = useState([]);
  const [selectedHamper, setSelectedHamper] = useState(null);
  const [loading, setLoading] = useState(true);
  const [imgFile, setImgFile] = useState(null);
  const [bannerImgFile, setBannerImgFile] = useState(null);
  const [settingList, setSettingList] = useState({
    address: "",
    contact: "",
    email: "",
    social_links: "",
  });

  const options = {
    loop: true,
    margin: 10,
    nav: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
        nav: true,
      },
      350: {
        items: 1.5,
        nav: true,
      },
      576: {
        items: 1.5,
        nav: true,
      },
      768: {
        items: 2,
        nav: true,
      },
      992: {
        items: 4,
        nav: true,
      },
      1200: {
        items: 4,
        nav: true,
      },
    },
  };

  const validations = {
    name: {
      pattern: /^[a-zA-Z\s]{2,50}$/,
      message: "Name should be 2-50 characters long and contain only letters"
    },
    company_name: {
      pattern: /^[a-zA-Z0-9\s\-&,.]{2,100}$/,
      message: "Company name should be 2-100 characters long and contain valid characters"
    },
    phone: {
      pattern: /^[6-9]\d{9}$/,
      message: "Please enter a valid 10-digit Indian mobile number"
    },
    email: {
      pattern: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
      message: "Please enter a valid email address"
    },
    location: {
      pattern: /^[a-zA-Z0-9\s,.-]{3,100}$/,
      message: "Location should be 3-100 characters long"
    },
    boxes_number: {
      pattern: /^[1-9][0-9]{0,4}$/,
      message: "Please enter a valid number between 1 and 99999"
    },
    comments: {
      pattern: /^[\s\S]{10,500}$/,
      message: "Comments should be between 10 and 500 characters"
    }
  };

  const [values, setValues] = useState({
    name: "",
    company_name: "",
    phone: "",
    email: "",
    location: "",
    boxes_number: "",
    comments: "",
  });

  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});

  const customId = "custom-id-yes";
  const handleChange = (e) => {
    const { name, value } = e.target;
    setValues((prevValues) => ({
      ...prevValues,
      [name]: value,
    }));
    
    // Validate on change
    if (touched[name]) {
      validateField(name, value);
    }
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    setTouched(prev => ({
      ...prev,
      [name]: true
    }));
    validateField(name, value);
  };

  const validateField = (name, value) => {
    const validation = validations[name];
    let newErrors = { ...errors };

    if (!value.trim()) {
      newErrors[name] = `${name.replace('_', ' ')} is required`;
    } else if (validation?.pattern && !validation.pattern.test(value)) {
      newErrors[name] = validation.message;
    } else {
      delete newErrors[name];
    }

    setErrors(newErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Touch all fields
    const touchedFields = Object.keys(values).reduce((acc, key) => ({
      ...acc,
      [key]: true
    }), {});
    setTouched(touchedFields);

    // Validate all fields
    let formErrors = {};
    Object.keys(values).forEach(key => {
      validateField(key, values[key]);
      if (errors[key]) {
        formErrors[key] = errors[key];
      }
    });

    if (Object.keys(formErrors).length > 0) {
      toast.error("Please fix the form errors");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/corporate-gift-requests`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(values),
        }
      );
      const data = await response.json();
      if (data.success) {
        toast.success("Enquiry submitted successfully!");
        // Reset form
        setValues({
          name: "",
          company_name: "",
          phone: "",
          email: "",
          location: "",
          boxes_number: "",
          comments: ""
        });
        setTouched({});
        setErrors({});
        // Close modal
        document.querySelector('[data-bs-dismiss="modal"]').click();
      } else {
        toast.error(data.message || "Something went wrong!");
      }
    } catch (error) {
      toast.error("Failed to submit enquiry");
    }
  };

  const fetchSettingList = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/settings`, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      });
      const data = await res.json();
      // console.log("data", data);
      setSettingList(data.responseObject);
      // console.log("res", res)
    } catch (error) {
      // console.log("error fetch faq", error);
    }
  };

  const fetchHamperList = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/hampers`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      setHamperList(data.responseObject);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      // console.log("error fetch hampers", error);
    }
  };

  const fetchSelectedHamper = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/hampers/${id}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      const data = await res.json();
      // console.log("data", data);
      setSelectedHamper(data.responseObject);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      // console.log("error fetch hamper", error);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    if (id) {
      fetchSelectedHamper();
    }
    fetchHamperList();
    fetchSettingList();
  }, [id]);

  const handleWhatsAppShare = () => {
    // Remove any non-numeric characters and get just the numbers
    const contactNumber = settingList?.whatsappNo;

    if (contactNumber) {
      // Create WhatsApp URL with the contact number
      const whatsappUrl = `https://wa.me/${contactNumber}`;
      window.open(whatsappUrl, "_blank");
    }
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <>
      {/* Hero Banner Section */}
      <section
        className="hero-section"
        style={{
          background: "linear-gradient(314deg, #6828CBFF 30%, #71C4FFFF 100%)",
          padding: "60px 0",
          marginTop: "100px",
        }}
      >
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <div style={{ color: "white" }}>
                <h1 style={{ fontSize: "4rem", marginBottom: "20px" }}>
                  Corporate Celebration Crafters
                </h1>
                <p
                  style={{
                    fontSize: "1.5rem",
                    marginBottom: "30px",
                    color: "white",
                  }}
                >
                  Make your corporate gifting memorable with our customized
                  hampers
                </p>
                <div className="d-flex gap-3">
                  <button
                    className="thm-btn"
                    onClick={handleWhatsAppShare}
                    style={{
                      background: "transparent",
                      color: "white",
                      border: "2px solid white",
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    <i
                      className="fab fa-whatsapp"
                      style={{ fontSize: "20px" }}
                    ></i>
                    WhatsApp Now
                  </button>
                  <button
                    className="thm-btn"
                    data-bs-toggle="modal"
                    data-bs-target="#custom-quote"
                    style={{
                      background: "transparent",
                      border: "2px solid white",
                      color: "white",
                    }}
                  >
                    Customize your hamper
                  </button>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <img
                src={selectedHamper?.image[0]}
                alt="Corporate Gift"
                style={{
                  width: "100%",
                  borderRadius: "10px",
                }}
              />
            </div>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section style={{ padding: "60px 0", background: "#f5f5f5" }}>
        <div className="container">
          <h2 className="text-center mb-5">How It Works</h2>
          <div className="row">
            <div className="col-md-4 text-center">
              <div
                style={{
                  background: "white",
                  padding: "30px",
                  borderRadius: "10px",
                  height: "100%",
                }}
              >
                <i
                  className="fas fa-comments mb-3"
                  style={{ fontSize: "2rem", color: "#4a148c" }}
                ></i>
                <h4>Tell us about your needs</h4>
                <p>Share your requirements and preferences</p>
              </div>
            </div>
            <div className="col-md-4 text-center">
              <div
                style={{
                  background: "white",
                  padding: "30px",
                  borderRadius: "10px",
                  height: "100%",
                }}
              >
                <i
                  className="fas fa-gift mb-3"
                  style={{ fontSize: "2rem", color: "#4a148c" }}
                ></i>
                <h4>We will build your gift hamper</h4>
                <p>Customize according to your preferences</p>
              </div>
            </div>
            <div className="col-md-4 text-center">
              <div
                style={{
                  background: "white",
                  padding: "30px",
                  borderRadius: "10px",
                  height: "100%",
                }}
              >
                <i
                  className="fas fa-truck mb-3"
                  style={{ fontSize: "2rem", color: "#4a148c" }}
                ></i>
                <h4>Get Pan-India Delivery</h4>
                <p>Fast and reliable delivery across India</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Corporate Gifts Section */}
      <section style={{ padding: "60px 0" }}>
        <div className="container">
          <h2 className="text-center mb-5">Our Gift Collections</h2>
          <OwlCarousel
            className="owl-theme"
            key={hamperList.length}
            {...options}
          >
            {hamperList.map((hamper) => (
              hamper.status === true && (
              <div key={hamper._id} style={{ padding: "15px" }}>
                <Link to={`/corporategift/${hamper._id}`}>
                  <div
                    style={{
                      background: "white",
                      borderRadius: "10px",
                      overflow: "hidden",
                      boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                    }}
                  >
                    <img
                      src={hamper.image[0]}
                      alt={hamper.name}
                      style={{
                        width: "100%",
                        height: "250px",
                        objectFit: "cover",
                      }}
                    />
                    <div
                      style={{
                        padding: "20px",
                        minHeight: "150px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      <h5>{hamper.name}</h5>
                    </div>
                  </div>
                </Link>
                </div>
              )
            ))}
          </OwlCarousel>
        </div>
      </section>

      {/* Rest of the existing code for modal and form */}
      <div
        className="modal fade registration"
        id="custom-quote"
        tabIndex={-1}
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered modal-lg">
          <div
            className="modal-content"
            style={{ borderRadius: "15px", background: "#fff" }}
          >
            <div className="modal-header border-bottom-0 px-4 pt-4 pb-0">
              <h5
                className="modal-title fw-bold"
                style={{ fontSize: "28px", color: "#333" }}
              >
                Request a Custom Quote
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                style={{
                  fontSize: "30px",
                  color: "white",
                  background: "none",
                }}
              >
                <i className="fas fa-times"></i>
              </button>
            </div>
            <div className="modal-body px-4 pt-3">
              <form onSubmit={handleSubmit}>
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        className="form-label fw-medium mb-2"
                        style={{ color: "#444" }}
                      >
                        Name *
                      </label>
                      <input
                        type="text"
                        name="name"
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control form-control-lg ${
                          touched.name && errors.name ? 'is-invalid' : 
                          touched.name && !errors.name ? 'is-valid' : ''
                        }`}
                        placeholder="Enter your name"
                      />
                      {touched.name && errors.name && (
                        <div className="invalid-feedback">{errors.name}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        className="form-label fw-medium mb-2"
                        style={{ color: "#444" }}
                      >
                        Company Name *
                      </label>
                      <input
                        type="text"
                        name="company_name"
                        value={values.company_name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control form-control-lg ${
                          touched.company_name && errors.company_name ? 'is-invalid' : 
                          touched.company_name && !errors.company_name ? 'is-valid' : ''
                        }`}
                        placeholder="Enter company name"
                      />
                      {touched.company_name && errors.company_name && (
                        <div className="invalid-feedback">{errors.company_name}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        className="form-label fw-medium mb-2"
                        style={{ color: "#444" }}
                      >
                        Mobile Number *
                      </label>
                      <input
                        type="tel"
                        name="phone"
                        value={values.phone}
                        onChange={handleChange}
                        className={`form-control form-control-lg ${
                          touched.phone && errors.phone ? 'is-invalid' : 
                          touched.phone && !errors.phone ? 'is-valid' : ''
                        }`}
                        placeholder="Enter mobile number"
                        maxLength="10"
                        minLength="10"
                      />
                      {touched.phone && errors.phone && (
                        <div className="invalid-feedback">{errors.phone}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        className="form-label fw-medium mb-2"
                        style={{ color: "#444" }}
                      >
                        Email Address *
                      </label>
                      <input
                        type="email"
                        name="email"
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control form-control-lg ${
                          touched.email && errors.email ? 'is-invalid' : 
                          touched.email && !errors.email ? 'is-valid' : ''
                        }`}
                        placeholder="Enter email address"
                      />
                      {touched.email && errors.email && (
                        <div className="invalid-feedback">{errors.email}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        className="form-label fw-medium mb-2"
                        style={{ color: "#444" }}
                      >
                        Location *
                      </label>
                      <input
                        type="text"
                        name="location"
                        value={values.location}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control form-control-lg ${
                          touched.location && errors.location ? 'is-invalid' : 
                          touched.location && !errors.location ? 'is-valid' : ''
                        }`}
                        placeholder="Enter your location"
                      />
                      {touched.location && errors.location && (
                        <div className="invalid-feedback">{errors.location}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label
                        className="form-label fw-medium mb-2"
                        style={{ color: "#444" }}
                      >
                        Number of Boxes *
                      </label>
                      <input
                        type="number"
                        name="boxes_number"
                        value={values.boxes_number}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control form-control-lg ${
                          touched.boxes_number && errors.boxes_number ? 'is-invalid' : 
                          touched.boxes_number && !errors.boxes_number ? 'is-valid' : ''
                        }`}
                        placeholder="Enter number of boxes"
                        min="1"
                      />
                      {touched.boxes_number && errors.boxes_number && (
                        <div className="invalid-feedback">{errors.boxes_number}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="form-group">
                      <label
                        className="form-label fw-medium mb-2"
                        style={{ color: "#444" }}
                      >
                        Comments *
                      </label>
                      <textarea
                        name="comments"
                        value={values.comments}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        className={`form-control form-control-lg ${
                          touched.comments && errors.comments ? 'is-invalid' : 
                          touched.comments && !errors.comments ? 'is-valid' : ''
                        }`}
                        style={{
                          borderRadius: "10px",
                          padding: "12px 15px",
                          border: "1px solid #ddd",
                          height: "120px",
                          resize: "none",
                          fontSize: "15px",
                        }}
                        placeholder="Enter your requirements or any specific details"
                      />
                      {touched.comments && errors.comments && (
                        <div className="invalid-feedback">{errors.comments}</div>
                      )}
                    </div>
                  </div>
                  <div className="col-12 mt-4">
                    <button
                      className="btn btn-primary w-100"
                      type="submit"
                      style={{
                        background: "#8231D3",
                        border: "none",
                        borderRadius: "10px",
                        padding: "15px",
                        fontSize: "16px",
                        fontWeight: "600",
                        textTransform: "uppercase",
                        letterSpacing: "0.5px",
                        transition: "all 0.3s ease",
                        marginBottom: "20px",
                      }}
                      onMouseOver={(e) =>
                        (e.target.style.background = "#6a28aa")
                      }
                      onMouseOut={(e) =>
                        (e.target.style.background = "#8231D3")
                      }
                      disabled={Object.keys(errors).length > 0}
                    >
                      Submit Enquiry
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CorporateGifting;
